import { DatePickerField, Modal, SwitchField } from '@oforce/global-components';
import { Formik } from 'formik';
import { GraphQLErrors } from '../../../components';
import * as yup from 'yup';
import moment from 'moment';

export default function ShowDocumentDownloadModal({ show, toggle, populateDocument, loading, error }) {
  const validationSchema = yup
    .object()
    .shape({ activeOn: yup.date().required('Required'), includeStakeholders: yup.bool() });
  const initialValues = { activeOn: moment(), includeStakeholders: true };

  return (
    <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={populateDocument}>
      {formik => (
        <Modal
          isOpen={show}
          toggle={toggle}
          title="Download Document"
          submitButtonText="Download"
          onSubmit={formik.handleSubmit}
          submitButtonProps={{ loadingText: 'Downloading...' }}
          loading={loading}
          onOpened={() => {
            formik.resetForm({ values: initialValues });
          }}
        >
          <GraphQLErrors error={error} />
          <DatePickerField fullWidth required name="activeOn" label="Active On" format="MM/DD/YYYY" />
          <SwitchField
            id="includeStakeholders"
            className="mb-3"
            label="Include Stakeholder Documents"
            name="includeStakeholders"
            size="sm"
            switchLabel={formik?.values?.includeStakeholders ? 'Included' : 'Not Included'}
          />
        </Modal>
      )}
    </Formik>
  );
}
